<div>
  <div class="flex items-center mt1">
    <span><b>Contacts</b></span>
    <mat-icon *ngIf="hasPermissions"
              class="add-icon"
              color="primary"
              matTooltip="Add contact detail"
            (click)="OnAddContactDetails()">add
    </mat-icon>
  </div>

  <div *ngIf="contacts && contacts.length > 0">
    <ul>
      <li *ngFor="let contact of contacts" class="flex items-center">
        <span class="m-r-10">{{getContactString(contact)}}</span>
      <ng-container *ngIf="hasPermissions">
        <mat-icon class="edit-icon" color="primary"
                  matTooltip="Edit contact details"
                  (click)="OnEditContactDetails(contact)">edit
        </mat-icon>
        <mat-icon class="edit-icon" color="primary"
                  matTooltip="Delete contact details"
                  (click)="OnDeleteContactDetails(contact)">delete
        </mat-icon>
      </ng-container>
      </li>
    </ul>
  </div>
  <div *ngIf="!contacts || contacts.length === 0">
    <p>No contact information found.</p>
  </div>
</div>